/**
 * localStorage can throw (Safari private mode, strict tracking) or be unavailable.
 * Use for Zustand persist and theme so the app still boots.
 */

function getStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    const k = '__codemerlin_ls__';
    window.localStorage.setItem(k, '1');
    window.localStorage.removeItem(k);
    return window.localStorage;
  } catch {
    return null;
  }
}

export function safeLocalStorageGet(key: string): string | null {
  const s = getStorage();
  if (!s) return null;
  try {
    return s.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSet(key: string, value: string): void {
  const s = getStorage();
  if (!s) return;
  try {
    s.setItem(key, value);
  } catch {
    /* quota / private mode */
  }
}

export function safeLocalStorageRemove(key: string): void {
  const s = getStorage();
  if (!s) return;
  try {
    s.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Zustand persist storage that never throws */
export function createZustandSafeStorage(): Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> {
  return {
    getItem: (name) => safeLocalStorageGet(name),
    setItem: (name, value) => safeLocalStorageSet(name, value),
    removeItem: (name) => safeLocalStorageRemove(name),
  };
}
